module.exports = __webpack_public_path__ + "static/Point_cloud_torus-d629eab2dacf3e25d0ee3cbf5fd2bcf4.gif";